module.exports = __webpack_public_path__ + "static/ss6.9b82bcb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/projects/studysmart/ss/ss6.png
// module id = 1202
// module chunks = 81679748166845